(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-shipping-bar"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
      new Swiper('.slider-wrapper', {
        loop: '{{ section.settings.loop }}',
        slidesPerView: '{{ section.settings.slides_per_view }}',
        spaceBetween: '{{ section.settings.space_between }}',
        loopedSlides: 3,
        autoplay: {
            enabled: '{{ section.settings.slide_autoplay }}',
            delay: 3500,
            disableOnInteraction: true
        },
        breakpoints: {
          320: {
              slidesPerView: 1,
              spaceBetween: 5
          },
          825: {
              slidesPerView: 2,
              spaceBetween: 5
          },
          1024: {
              slidesPerView: 3,
              spaceBetween: 5
          }
        }
      });
  });
  

  } catch(e) { console.error(e); }
})();
})();
